export function blockTestRender() {
  return process.env.NODE_ENV !== 'test';
}

export function isDevelopment() {
  return process.env.NODE_ENV === 'development';
}
